import { useZendesk } from 'hooks/useZendesk';
import 'components/Zendesk/zendesk.css';
import { shallowEqual, useSelector } from 'react-redux';
import { customerLoadingStateSelector, customerSelector } from 'store/customer/selectors';

export const SPLIT_IO_FEATURE_FLAG_ZEN_DESK = 'FeatureFlag-ZenDesk';
export const SPLIT_IO_FEATURE_FLAG_ZEN_DESK_COOKIE = 'au_split_feature_flag_zen_desk';

export const ZenDesk = (): null => {
  const customer = useSelector(customerSelector);
  const customerLoadingState = useSelector(customerLoadingStateSelector, shallowEqual);
  useZendesk({ customer, customerLoadingState });

  return null;
};
